import { gql } from '@apollo/client';

export const IS_USER_FOLLOWING_STORE = gql`
  query IsUserFollowingStore($input: IsUserFollowingStoreInput!) {
    isUserFollowingStore(input: $input) {
      isFollowing
    }
  }
`;

export const GET_NUMBER_OF_FOLLOWERS = gql`
  query GetNumberOfFollowers($input: GetNumberOfFollowersInput!) {
    getNumberOfFollowers(input: $input) {
      count
    }
  }
`;

export const GET_FOLLOWERS = gql`
  query GetFollowers($input: GetFollowersInput!) {
    getFollowers(input: $input) {
      entities {
        id
        followerId
        storeId
        isFollowing
        createdAt
        follower {
          id
          firstName
          lastName
          slug
          role
          storeDetails {
            id
            avatarURL
          }
        }
      }
      total
      limit
      offset
    }
  }
`;
